module.exports = __webpack_public_path__ + "img/banner-6-en.fad8ec23.jpg";